import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הקושי",
    opening: localizedGenderNode(
      [
      "היום אני לא מכריח/ה את עצמי לקום.",
      "אני רק שם/ה לב: קשה לי להתחיל את היום.",
      "אני כאן."
    ],
      [
      "היום אני לא מכריח/ה את עצמי לקום.",
      "אני רק שם/ה לב: קשה לי להתחיל את היום.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מתי הבוקר הכי כבד לי?",
      "אני שואל/ת את עצמי, בשקט: מה המחשבה הראשונה כשאני פוקח/ת עיניים?",
      "אני שואל/ת את עצמי, בשקט: מה אני מרגיש/ה בגוף?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מתי הבוקר הכי כבד לי?",
      "אני שואל/ת את עצמי, בשקט: מה המחשבה הראשונה כשאני פוקח/ת עיניים?",
      "אני שואל/ת את עצמי, בשקט: מה אני מרגיש/ה בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הקושי הוא חוויה, לא אני."
    ],
      [
      "הקושי הוא חוויה, לא אני."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני כאן עם הבוקר\".",
      "נשימה אחת + \"אני כאן עם הבוקר\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שבו הקושי מתחיל.",
      "אני רק שם/ה לב.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני שם/ה לב לרגע שבו הקושי מתחיל.",
      "אני רק שם/ה לב.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה קורה ממש לפני שאני מוותר/ת על הקימה?",
      "אני שואל/ת את עצמי, בשקט: איפה זה פוגש אותי בבוקר?",
      "אני שואל/ת את עצמי, בשקט: מה אני מנסה להימנע ממנו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה קורה ממש לפני שאני מוותר/ת על הקימה?",
      "אני שואל/ת את עצמי, בשקט: איפה זה פוגש אותי בבוקר?",
      "אני שואל/ת את עצמי, בשקט: מה אני מנסה להימנע ממנו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי מעט מרחב."
    ],
      [
      "ברגע הראשון יש לי מעט מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשזה מתחיל.",
      "נשימה אחת כשזה מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "סימני הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי.",
      "אני כאן."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איפה הגוף מרגיש את הקושי?",
      "אני שואל/ת את עצמי, בשקט: מה הגוף שלי מנסה להגן?",
      "אני שואל/ת את עצמי, בשקט: מה יכול להתרכך קצת?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איפה הגוף מרגיש את הקושי?",
      "אני שואל/ת את עצמי, בשקט: מה הגוף שלי מנסה להגן?",
      "אני שואל/ת את עצמי, בשקט: מה יכול להתרכך קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף שלי מנסה לשמור עליי."
    ],
      [
      "הגוף שלי מנסה לשמור עליי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה העובדה הפשוטה כאן?",
      "אני שואל/ת את עצמי, בשקט: איזה סיפור קפץ לי?",
      "אני שואל/ת את עצמי, בשקט: איזו אפשרות רכה יכולה להיות נכונה גם היא?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה העובדה הפשוטה כאן?",
      "אני שואל/ת את עצמי, בשקט: איזה סיפור קפץ לי?",
      "אני שואל/ת את עצמי, בשקט: איזו אפשרות רכה יכולה להיות נכונה גם היא?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה נעלם",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שנעלם בי בבוקר.",
      "לא כדי להאשים.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני שם/ה לב למה שנעלם בי בבוקר.",
      "לא כדי להאשים.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה בדרך כלל חסר לי בבוקר?",
      "אני שואל/ת את עצמי, בשקט: מתי אני מרגיש/ה מעט יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה אני מתגעגע/ת אליו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה בדרך כלל חסר לי בבוקר?",
      "אני שואל/ת את עצמי, בשקט: מתי אני מרגיש/ה מעט יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה אני מתגעגע/ת אליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב למה שנעלם זה כבר קשר."
    ],
      [
      "לשים לב למה שנעלם זה כבר קשר."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב דבר אחד שחסר לי.",
      "לכתוב דבר אחד שחסר לי."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול הפנימי שלי.",
      "בלי להכריח.",
      "אני כאן."
    ],
      [
      "היום אני מקשיב/ה לקול הפנימי שלי.",
      "בלי להכריח.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרפה את הכתפיים מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרפה את הכתפיים מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה הקול הפנימי שלי אומר על הקימה?",
      "אני שואל/ת את עצמי, בשקט: מה הקול הזה בוחר/ת ממני?",
      "אני שואל/ת את עצמי, בשקט: מה נשמע רך יותר בתוכי?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה הקול הפנימי שלי אומר על הקימה?",
      "אני שואל/ת את עצמי, בשקט: מה הקול הזה בוחר/ת ממני?",
      "אני שואל/ת את עצמי, בשקט: מה נשמע רך יותר בתוכי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול פנימי עדין הוא התחלה."
    ],
      [
      "קול פנימי עדין הוא התחלה."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי אחד רך.",
      "משפט פנימי אחד רך."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "צורך קטן",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך שמתחת לקושי.",
      "אני לא פותר/ת.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך שמתחת לקושי.",
      "אני לא פותר/ת.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ],
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה כדי להרגיש קצת יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה בי מבקש חום או קרבה?",
      "אני שואל/ת את עצמי, בשקט: איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה כדי להרגיש קצת יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה בי מבקש חום או קרבה?",
      "אני שואל/ת את עצמי, בשקט: איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מאחורי קושי יש בקשה."
    ],
      [
      "מאחורי קושי יש בקשה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב בקשה אחת לעצמי.",
      "לכתוב בקשה אחת לעצמי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חיבור קטן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי.",
      "אני כאן."
    ],
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה נותן לי תחושת חיבור עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איזו מילה מרגיעה אותי?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לתת לעצמי לרגע?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה נותן לי תחושת חיבור עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איזו מילה מרגיעה אותי?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לתת לעצמי לרגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חיבור קטן גם הוא חיבור."
    ],
      [
      "חיבור קטן גם הוא חיבור."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שקטה בלב.",
      "מילה אחת שקטה בלב."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "חמלה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מדבר/ת עם עצמי בעדינות.",
      "לא כמו שופט/ת.",
      "אני כאן."
    ],
      [
      "היום אני מדבר/ת עם עצמי בעדינות.",
      "לא כמו שופט/ת.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איך הייתי מדבר/ת לחבר/ה במקום הזה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לסלוח לעצמי עליו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איך הייתי מדבר/ת לחבר/ה במקום הזה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לסלוח לעצמי עליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עדינות לא מבטלת את הקושי."
    ],
      [
      "עדינות לא מבטלת את הקושי."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לעצמי.",
      "משפט רך אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה פנימית",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה.",
      "אני כאן."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הבטן נרגעת מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הבטן נרגעת מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה הבקשה הכי חשובה שלי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך לומר אותה במשפט אחד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה הבקשה הכי חשובה שלי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך לומר אותה במשפט אחד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לעזור לי לנוע."
    ],
      [
      "בקשה אחת יכולה לעזור לי לנוע."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך עדין",
    opening: localizedGenderNode(
      [
      "היום אני מזכיר/ה לעצמי ערך קטן שמחזיק אותי.",
      "לא גדול.",
      "אני כאן."
    ],
      [
      "היום אני מזכיר/ה לעצמי ערך קטן שמחזיק אותי.",
      "לא גדול.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לפנים רגועות.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לפנים רגועות.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איזה ערך קטן חשוב לי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך הערך הזה נראה ביום רגיל?",
      "אני שואל/ת את עצמי, בשקט: מה צעד פנימי קטן שמכבד אותו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איזה ערך קטן חשוב לי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך הערך הזה נראה ביום רגיל?",
      "אני שואל/ת את עצמי, בשקט: מה צעד פנימי קטן שמכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך קטן נותן לי כיוון."
    ],
      [
      "ערך קטן נותן לי כיוון."
    ]
    ),
    action: localizedGenderNode(
      "לבחור ערך אחד ולחזור עליו בלב.",
      "לבחור ערך אחד ולחזור עליו בלב."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "איך אני עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך אני מתייחס/ת לעצמי.",
      "אני לא שופט/ת.",
      "אני כאן."
    ],
      [
      "היום אני בודק/ת איך אני מתייחס/ת לעצמי.",
      "אני לא שופט/ת.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לעצמי חצי דקה של שקט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לעצמי חצי דקה של שקט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: באיזה רגע אני נלחץ/ת מעצמי?",
      "אני שואל/ת את עצמי, בשקט: איפה אני יכול/ה להרפות קצת?",
      "אני שואל/ת את עצמי, בשקט: איך אני רוצה לדבר עם עצמי בעתיד?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: באיזה רגע אני נלחץ/ת מעצמי?",
      "אני שואל/ת את עצמי, בשקט: איפה אני יכול/ה להרפות קצת?",
      "אני שואל/ת את עצמי, בשקט: איך אני רוצה לדבר עם עצמי בעתיד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "איך שאני איתי חשוב כמו כל דבר."
    ],
      [
      "איך שאני איתי חשוב כמו כל דבר."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של כבוד לעצמי.",
      "משפט אחד של כבוד לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "שינוי קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן שאפשר להחזיק.",
      "לא מהפכה.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת שינוי קטן שאפשר להחזיק.",
      "לא מהפכה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגוף יציב לרגע.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגוף יציב לרגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה שינוי קטן יכול לעזור לי בבוקר?",
      "אני שואל/ת את עצמי, בשקט: איך זה ייראה בפועל?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לנסות פעם אחת?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה שינוי קטן יכול לעזור לי בבוקר?",
      "אני שואל/ת את עצמי, בשקט: איך זה ייראה בפועל?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לנסות פעם אחת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק זה מספיק."
    ],
      [
      "קטן מספיק זה מספיק."
    ]
    ),
    action: localizedGenderNode(
      "צעד אחד קטן לעצמי.",
      "צעד אחד קטן לעצמי."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת ברוך.",
      "אני בוחר/ת משפט שמחזיר אותי.",
      "אני כאן."
    ],
      [
      "היום אני מסיים/ת ברוך.",
      "אני בוחר/ת משפט שמחזיר אותי.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה אוויר נכנס ויוצא.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה אוויר נכנס ויוצא.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה למדתי על הקושי הזה?",
      "אני שואל/ת את עצמי, בשקט: מה הסימן המוקדם שהוא עולה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט מחזיר אותי לרגע לפני?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה למדתי על הקושי הזה?",
      "אני שואל/ת את עצמי, בשקט: מה הסימן המוקדם שהוא עולה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט מחזיר אותי לרגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ],
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת ומשפט החזרה שלי.",
      "נשימה אחת ומשפט החזרה שלי."
    ),
  },
].map(buildNormalizedDay);

export const difficultyGettingUpInTheMorningFeelingThatThereIsAReasonBlueprintHe = buildNormalizedPilotBlueprint({
  id: "difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "קושי לקום בבוקר / להרגיש שיש למה",
    en: "Difficulty getting up in the morning / feeling that there is a reason",
    es: "Dificultad para levantarse por la mañana / sentir que hay una razón",
  },
  days,
});

export default difficultyGettingUpInTheMorningFeelingThatThereIsAReasonBlueprintHe;
